var _g, _g2, _g3, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirGapPumpConnOnValveOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Air_Gap_Pump_Connections_ON-Condenser_Valve_ON",
    "data-name": "Air Gap Pump + Connections ON-Condenser Valve ON",
    xmlns: "http://www.w3.org/2000/svg",
    width: 270,
    height: 138.999,
    viewBox: "0 0 270 138.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9831",
    "data-name": "Group 9831",
    transform: "translate(13.14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3867",
    "data-name": "Path 3867",
    d: "M15.73,95.267a2.6,2.6,0,0,1-2.59-2.6V10.631A10.623,10.623,0,0,1,23.73,0H267.4a2.6,2.6,0,0,1,0,5.2H23.73a5.414,5.414,0,0,0-5.4,5.42V92.657a2.6,2.6,0,0,1-2.6,2.61Z",
    transform: "translate(-13.14)",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9833",
    "data-name": "Group 9833",
    transform: "translate(58.827 47.943)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9832",
    "data-name": "Group 9832",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3868",
    "data-name": "Path 3868",
    d: "M63.92,106.014H58.83V57.991a8.529,8.529,0,0,1,8.42-8.621h44.478c.18,0,1.73-.04,1.73-1.43h5.09a6.586,6.586,0,0,1-6.82,6.64H67.25a3.372,3.372,0,0,0-3.33,3.41Z",
    transform: "translate(-58.829 -47.94)",
    fill: "#fff"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9834",
    "data-name": "Group 9834",
    transform: "translate(23.809 101.487)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4311",
    "data-name": "Rectangle 4311",
    width: 40.089,
    height: 5.21,
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9847",
    "data-name": "Group 9847",
    transform: "translate(0 92.697)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9837",
    "data-name": "Group 9837",
    transform: "translate(10.93)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9835",
    "data-name": "Group 9835",
    transform: "translate(0.33 0.32)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4312",
    "data-name": "Rectangle 4312",
    width: 8.69,
    height: 7.501,
    fill: "#00b7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9836",
    "data-name": "Group 9836"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3869",
    "data-name": "Path 3869",
    d: "M19.63,93.34v6.85H11.59V93.34h8.04m.64-.65H10.93v8.151h9.34V92.69Z",
    transform: "translate(-10.93 -92.69)",
    fill: "#404041"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9840",
    "data-name": "Group 9840",
    transform: "translate(26.729 8.331)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9838",
    "data-name": "Group 9838",
    transform: "translate(0.33 0.32)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4313",
    "data-name": "Rectangle 4313",
    width: 5.58,
    height: 5.6,
    fill: "#00b7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9839",
    "data-name": "Group 9839"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3870",
    "data-name": "Path 3870",
    d: "M32.31,101.67v4.95H27.38v-4.95h4.93m.65-.65H26.73v6.25h6.23Z",
    transform: "translate(-26.73 -101.02)",
    fill: "#404041"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9843",
    "data-name": "Group 9843",
    transform: "translate(3.71 7.381)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9841",
    "data-name": "Group 9841",
    transform: "translate(0.33 0.32)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4314",
    "data-name": "Rectangle 4314",
    width: 23.139,
    height: 8.521,
    fill: "#00b7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9842",
    "data-name": "Group 9842"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3871",
    "data-name": "Path 3871",
    d: "M26.849,100.72v7.871H4.36V100.72H26.849m.65-.65H3.71v9.171H27.5Z",
    transform: "translate(-3.71 -100.07)",
    fill: "#404041"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9846",
    "data-name": "Group 9846",
    transform: "translate(0 15.241)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9844",
    "data-name": "Group 9844",
    transform: "translate(0.32 0.32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3872",
    "data-name": "Path 3872",
    d: "M6.39,138.672a5.008,5.008,0,0,1-4.99-5.01V113.72H.32v-5.47H30.889v5.47h-1.08v19.941a5.008,5.008,0,0,1-4.99,5.01Z",
    transform: "translate(-0.32 -108.25)",
    fill: "#00b7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9845",
    "data-name": "Group 9845"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3873",
    "data-name": "Path 3873",
    d: "M30.569,108.58v4.81h-1.08v20.271a4.671,4.671,0,0,1-4.67,4.68H6.39a4.678,4.678,0,0,1-4.67-4.68V113.4H.65v-4.81H30.569m.65-.66H0v6.11H1.08v19.621a5.324,5.324,0,0,0,5.31,5.33H24.819a5.324,5.324,0,0,0,5.31-5.33V114.04h1.08v-6.11Z",
    transform: "translate(0 -107.93)",
    fill: "#404041"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9850",
    "data-name": "Group 9850",
    transform: "translate(51.158 66.575)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9848",
    "data-name": "Group 9848",
    transform: "translate(1.2 0.66)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3874",
    "data-name": "Path 3874",
    d: "M52.36,89.372,59.72,78.3,52.36,67.23H70.329L62.97,78.3l7.36,11.071Z",
    transform: "translate(-52.36 -67.23)",
    fill: "#ff16e3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9849",
    "data-name": "Group 9849"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3875",
    "data-name": "Path 3875",
    d: "M69.129,67.88l-3.89,5.85L62.2,78.3l3.04,4.57,3.89,5.85H53.57l3.89-5.85L60.5,78.3l-3.04-4.57-3.89-5.85H69.129m2.41-1.31H51.16l1.35,2.03,3.89,5.85,2.56,3.84L56.4,82.13l-3.89,5.85-1.35,2.03H71.539l-1.35-2.03L66.3,82.13l-2.56-3.84,2.56-3.84,3.89-5.85Z",
    transform: "translate(-51.16 -66.57)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirGapPumpConnOnValveOn);
export default __webpack_public_path__ + "static/media/air_gap_pump_conn_on_valve_on.7466476966a45983d6636ee4d4e38262.svg";
export { ForwardRef as ReactComponent };